import { render, staticRenderFns } from "./ChoiceValue.vue?vue&type=template&id=c187579e"
import script from "./ChoiceValue.vue?vue&type=script&lang=js"
export * from "./ChoiceValue.vue?vue&type=script&lang=js"
import style0 from "./ChoiceValue.vue?vue&type=style&index=0&id=c187579e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports